import { toString } from 'utils/pivot/product'
import store from 'utils/store/withMiddleware'

const filtersByRange = ['coinsurance', 'coverage', 'deductible', 'moop', 'price']

function filterAsQueryString() {
  const state = store.getState()
  const filters = state.filters
  const filterParams = []

  if (filters.period) {
    filterParams.push(`period=${filters.period}`)
  }

  if (filters.type.length > 0) {
    filterParams.push(`type=${filters.type.map(toString).join(',')}`)
  }

  if (filters.networkProvider.length > 0) {
    filterParams.push(`network_provider=${filters.networkProvider.join(',')}`)
  }

  if (filters.benefits.length > 0) {
    filterParams.push(`benefits=${filters.benefits.join(',')}`)
  }

  for (const name of filtersByRange) {
    const filter = filters[name]
    if ('min' in filter && 'max' in filter) {
      filterParams.push(`${name}=${filter.min},${filter.max}`)
    }
  }

  if (state.sortBy) {
    filterParams.push(`sort=${state.sortBy}`)
  }

  return filterParams.join('&')
}

export default filterAsQueryString
